module.exports = __webpack_public_path__ + "img/banner03_03.c4f73010.png";